
import { DEFAULT_HEX_RADIUS } from '../../../Constants';
import { TwoDTransform, TwoDVector3 } from './TwoDTransform';

function rotatePoint(x, y, centerx, centery, degrees) {
    var newx = (x - centerx) * Math.cos(degrees * Math.PI / 180) - (y - centery) * Math.sin(degrees * Math.PI / 180) + centerx;
    var newy = (x - centerx) * Math.sin(degrees * Math.PI / 180) + (y - centery) * Math.cos(degrees * Math.PI / 180) + centery;
    return [newx, newy];
}



export class GridLocation2d {

    name = "GridLocation";
    index = null;

    grid = null;
    gridId = null;

    transform = new TwoDTransform("GridLocation");
    axialX = 0;
    axialY = 0;
    axialZ = 0;
    ring = 0;

    radius = DEFAULT_HEX_RADIUS - 0.06; // hand tweaked :(

    neighborCoordinates = [
        [0, -1, 1],
        [1, -1, 0],
        [1, 0, -1],
        [0, 1, -1],
        [-1, 1, 0],
        [-1, 0, 1],
    ];

    constructor(grid, gridId, axialX, axialZ, radius, rotation) {
        this.grid = grid;
        this.gridId = gridId;
        this.transform.name = `${grid.name} GridLocationTransform ${gridId}`
        this.transform.parent = grid.gridTransform;
        this.index = gridId;
        this.radius = radius;
        this.rotation = rotation;
        this.moveTo(axialX, axialZ);
    }

    moveTo = (axialX, axialZ) => {
        this.axialX = axialX;
        this.axialZ = axialZ;
        this.axialY = -1 * this.axialZ - this.axialX;
        this.reset();
    }

    reset = () => {
        this.setPosition();
        this.setRingNumber();
        this.resetNeighbors();
        this.setName();
    }

    setRadius = (radius) => {
        this.radius = radius;
        this.reset();
    }

    setPosition = () => {
        let hexOffset = this.axialX * 0.5;
        let hexX = (this.axialZ + hexOffset) * this.radius * 2;
        let hexZ = this.axialX * this.radius * 2 * 0.866025404; // SQR(3) / 2
        let hexY = 0; // height * 10;

        let result = rotatePoint(hexX, hexZ, 0, 0, this.rotation);
        hexX = result[0];
        hexZ = result[1]

        this.transform.position = new TwoDVector3(hexX, hexY, hexZ);
    }

    resetNeighbors = () => {
        this.resetNeighborCoordinates();
    }

    resetNeighborCoordinates = () => {
        this.neighborCoordinates = [
            [0, -1, 1],
            [1, -1, 0],
            [1, 0, -1],
            [0, 1, -1],
            [-1, 1, 0],
            [-1, 0, 1],
        ];
        this.adjustNeighborCoordinates();
    }

    adjustNeighborCoordinates = () => {
        // Move the neighbors to around the puck based on current location.
        let newNeighborCoordinates = []
        for (let i = 0; i < this.neighborCoordinates.length; ++i) {
            newNeighborCoordinates.push([
                this.neighborCoordinates[i][0] + this.axialX,
                this.neighborCoordinates[i][1] + this.axialY,
                this.neighborCoordinates[i][2] + this.axialZ,
            ])
        }
        this.neighborCoordinates = newNeighborCoordinates;
    }

    setRingNumber = () => {
        this.ring = Math.max(
            Math.abs(this.axialX),
            Math.abs(this.axialY),
            Math.abs(this.axialZ));
    }

    setName = () => {
        let position = this.transform.position
        this.name = `GridLocation id:${this.index} radial:${this.axialX}x${this.axialY}x${this.axialZ} position:${position.x}x${position.y}x${position.z}`;
    }

    render = (locationItem) => {
        return <div
            key={this.gridId}
            id={this.gridId}
            style={{
                position: 'absolute',
                left: this.transform.position.x,
                top: this.transform.position.z
            }}
        >
            {locationItem}
        </div>
    }

}
